import { ProFormaModelIds } from "constants/proForma";

export const PROJECT_PROFIT_TOOLTIP = 'Calculated as exit value plus operating cash flow during the hold period, '
    + 'minus the total development budget (including developer fee). Unlevered.';
export const PROJECT_PROFIT_MARGIN_TOOLTIP = 'Project profit divided by the total development budget';

export const SUPPORTED_EXECUTIVE_SUMMARY_EXPORT_MODELS = [
    ProFormaModelIds.APARTMENT,
    ProFormaModelIds.INDUSTRIAL,
    ProFormaModelIds.RETAIL,
    ProFormaModelIds.OFFICE,
    ProFormaModelIds.APARTMENT_WITH_RETAIL,
    ProFormaModelIds.DATA_CENTER,
    ProFormaModelIds.STUDENT_HOUSING,
    ProFormaModelIds.LAND_DEVELOPMENT,
];

export const PERCENTAGE_PRECISION = '0,0.00';
export const AREA_PRECISION = '0,0.[00]';
export const NO_VALUE = '—';
